export const createPasswordRules = (t) => [
    {
        key: "length",
        label: t("passwordRules.length"),
        message: t("passwordRules.length_error"),
        check: (value) => value.length >= 8 && value.length <= 20,
    },
    {
        key: "composition",
        label: t("passwordRules.composition"),
        check: (value) => {
            if (/\s/.test(value))
                return false;
            const kinds = [/[A-Z]/, /[a-z]/, /\d/, /[^A-Za-z0-9\s]/].filter((rule) => rule.test(value)).length;
            return kinds >= 3;
        },
    },
];
export const createPasswordValidator = (t) => (value) => {
    var _a;
    const password = typeof value === "string" ? value : "";
    if (!password)
        return undefined;
    const failedRule = createPasswordRules(t).find((rule) => !rule.check(password));
    return failedRule ? ((_a = failedRule.message) !== null && _a !== void 0 ? _a : failedRule.label) : undefined;
};
//# sourceMappingURL=password-rules.js.map